import React from 'react';

interface ChipListProps {
  text: string;
  bgColor: string;
  txtColor: string;
  width?: string;
  hrefPath: string;
  className?: string;
  target?: '_blank' | '_self';
  onClick?: ((e: any) => void);
}

const Chip: React.FC<ChipListProps> = ({
  text,
  bgColor,
  className = '',
  txtColor,
  width = '',
  hrefPath,
  target = '_self',
  onClick
}) => {
  const baseClass = `
    ${className} 
    font-bold whitespace-nowrap rounded-3xl px-4 py-2 
    hover:bg-lightblue active:bg-lightblue 
    hover:text-white active:text-white 
    transition duration-300 
    ${width} ${bgColor} ${txtColor}
    focus:outline focus:outline-2 focus:outline-blue-600
  `;


  if (hrefPath) {
    return (
      <a
        href={hrefPath}
        target={target}
        rel={target === '_blank' ? 'noopener noreferrer' : undefined}
        onClick={onClick}
        className={baseClass}
        aria-label={`Vai alla pagina ${text}`}
      >
        {text}
      </a>
    );
  }

  return (
    <button
      onClick={onClick}
      className={baseClass}
      aria-label={text}
    >
      {text}
    </button>
  );
};

export default Chip;
